module.exports = __webpack_public_path__ + "img/ae-4.4e298f1.png";